import { createSlice } from '@reduxjs/toolkit'
import { serializeDate } from '../../utils/date'

const routingActionsSlice = createSlice({
  name: 'routingActions',
  initialState: {
    actionSerializedServiceDate: null,
    assignStopDialog: {
      isOpen: false,
      stopToBeAssigned: {},
    },
    unassignConfirmDialog: {
      isOpen: false,
      accountId: '',
    },
  },
  reducers: {
    setIsAssignStopDialogOpen: (state, action) => {
      state.assignStopDialog.isOpen = action.payload
    },
    setStopToBeAssigned: (state, action) => {
      state.assignStopDialog.stopToBeAssigned = action.payload
    },
    setRoutingActionServiceDate: (state, action) => {
      state.actionSerializedServiceDate = serializeDate(action.payload)
    },
    setIsUnassignConfirmDialogOpen: (state, action) => {
      const isOpen = Boolean(action.payload)
      state.unassignConfirmDialog.isOpen = isOpen
      if (!isOpen) {
        // Clear accountId when dialog is closed to avoid stale values
        state.unassignConfirmDialog.accountId = ''
      }
    },
    setUnassignConfirmDialogAccountId: (state, action) => {
      state.unassignConfirmDialog.accountId = action.payload || ''
    },
  },
})

export const { setIsAssignStopDialogOpen, setStopToBeAssigned, setRoutingActionServiceDate, setIsUnassignConfirmDialogOpen, setUnassignConfirmDialogAccountId } = routingActionsSlice.actions

export default routingActionsSlice.reducer
